import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=78dd36b7&scoped=true&"
import script from "./TemplateList.vue?vue&type=script&lang=js&"
export * from "./TemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd36b7",
  null
  
)

export default component.exports